<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.entrance.entranceName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceId">
              <a-select v-model="model.entranceId" @change="entranceChange" :placeholder="language['common.pleaseChoose']+language['emp.col.entrance.entranceName']" allowClear :disabled="formDisabled">
                <a-select-option v-for="(item,index) in entrancelist" :key="index.toString()" :value="item.id"  >
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['ad.name']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="title">
              <a-input v-model="model.title" :placeholder="language['ad.must']+language['ad.name']"  style="width: 80%" :disabled="formDisabled"></a-input>
              <a-button @click="languageModelOpen('cms_banner','title',contentTitleLanguages)" type="primary"  style="left: 3%"  :disabled="formDisabled">{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" >
            <a-form-model-item :label="language['hhemp.ad.jump.type']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="linkType">
              <a-radio-group v-model="model.linkType" @change="filecontentChange" :disabled="formDisabled">
                <a-radio value="0" @click="contentTypeCh(true)">{{language['ad.link']}}</a-radio>
                <a-radio value="1" @click="contentTypeCh(false)">{{ language['eletronicSigned.fileUrls'] }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['hhemp.lang.setting']" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-tabs defaultActiveKey="1" style="border: 1px solid #262626;border-radius: 5px;">
                <a-tab-pane :tab="language[item.value]" :key="index" v-for="(item, index) in langList">

                  <a-col :span="24">
                    <a-form-model-item :label="language['hhemp.ad.img']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
                      <j-image-upload class="avatar-uploader" :text="language['common.uploadButton']" v-model="model[item.imgPath]" :upload-source="uploadSource" :multiple="false" :disabled="formDisabled"></j-image-upload>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="24" v-if="contentTypeChecked">
                    <a-form-model-item :label="language['ad.link']" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-textarea v-model="model[item.linkUrl]" :placeholder="language['ad.must']+language['ad.link']"  style="width: 80%" :disabled="formDisabled"></a-textarea>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="24" v-if="contentFileChecked">
                    <a-form-model-item :label="language['eletronicSigned.fileUrls']" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                      <j-upload file-type="file" :uploadSource="`hhemp`" bizPath="null"
                                :newWindowOpen="`true`" v-model="model[item.filePath]"
                                :disabled="formDisabled" @change="handleChange"
                                :number="0" :multiple="false" > </j-upload>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="24">
                    <a-form-model-item :label="language['hhemp.ad.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
                      <a-textarea v-model="model[item.introduction]" maxLength="1000"  rows="4" :placeholder="language['ad.must']+language['hhemp.ad.remark']" :disabled="formDisabled"  style="width: 80%"/>
                    </a-form-model-item>
                  </a-col>
                </a-tab-pane>
              </a-tabs>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['platform.roleUser.columns2.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="publishStatus">
              <a-radio-group v-model="model.status" @change="filecontentChange"  :disabled="formDisabled">
                <a-radio value="0" :readOnly="true">{{ language['ad.offline'] }}</a-radio>
                <a-radio value="1" :readOnly="true">{{ language['emp.col.status.publish'] }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.col.sortNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number :min="1" :max="999999" v-model="model.sortNo"  style="width: 100%" :placeholder="language['common.pleaseInput']+language['emp.col.sortNo']" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <language-model ref="languageModel" @ok="languageOk"></language-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JEditor from '@/components/jeecg/JEditor'
  import LanguageModel from "@/components/LanguageModel"
  export default {
    name: 'CmsBannerForm',
    components: {
      JEditor,
      LanguageModel
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
        colidProps: String,
    },
    data () {
      const { language } = this.$store.getters;
      return language &&  {
        isDisable:false,
        value:"222",
        model:{
            // cnData:{content:""},
            // twData:{content:""},
            // enData:{content:""}
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          entranceId:[
            { required: true, message: language['common.pleaseChoose']+language['emp.col.entrance.entranceName']},
          ],
          title: [
              { required: true, message: language['ad.must']+language['ad.name']},
           ],
           contentTitle: [
              { required: true, message: language['ad.must']+language['emp.develop.contTitle']},
           ],
           imgUrl: [
              { required: false, message: '请上传图片!'},
           ],
           sortNo: [
            {required: true, message: language['common.pleaseInput']+language['emp.col.sortNo']},
           /* {validator: this.validateToSortNo, trigger: 'blur'}*/
           ],
          linkType:[
            { required: true, message: language['common.pleaseChoose']+language['hhemp.ad.jump.type']},
          ]
           /*publishStatus: [
              { required: true, message: '请输入发布状态!'},
           ],
           delFlag: [
              { required: true, message: '请输入刪除标示!'},
           ],*/
        },
        url: {
          add: "/hhemp/banner/banners",
          edit: "/hhemp/banner/banners",
          queryById: "/hhemp/content/cmscontenttbl/"
        },
        uploadSource: 'hhemp',
        colVisible: false,
        cols:[],
        entrancelist:[],
        entranceId:'',
        colId:"",
        classificationId:'',
        classifications:[],
        isShowClassification:'',
        contentTypeChecked:true,
        contentFileChecked:false,
        langList:[
          {text:"中文简体",value:"zh_CN",filePath:"cnFilePaths",imgPath:"cnImgPath",linkUrl:"cnLink",introduction:"cnIntroduction"},
          {text:"中文繁体",value:"zh_TW",filePath:"twFilePaths",imgPath:"twImgPath",linkUrl:"twLink",introduction:"twIntroduction"},
          {text:"英文",value:"en_US",filePath:"enFilePaths",imgPath:"enImgPath",linkUrl:"enLink",introduction:"enIntroduction"},
          {text:"越南語",value:"vi_VN",filePath:"viFilePaths",imgPath:"viImgPath",linkUrl:"viLink",introduction:"viIntroduction"}

        ],
        contentTitleLanguages:[],
        contentSubTitleLanguages:[],
        remarkLanguages:[],

      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
    },
    created () {

      this.initLangListData();
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.initEntrancelist();
    },
    methods: {
      initLangListData(){
        //从缓存中获取数据模板多语言
        let  languageList= this.$store.getters.languagelist;
        let initLanguageList=[];
        let that=this;
        languageList.forEach(item => {
          let foundObject = that.langList.find(function(obj) {
            return obj.value === item.value;
          });

          if(foundObject!=null){
            initLanguageList.push(foundObject);
          }
        })

        this.langList=initLanguageList;

      },
      contentTypeCh(tag){
        if(tag){
          this.contentTypeChecked=true;
          this.contentFileChecked=false;
        }else{
          this.contentTypeChecked=false;
          this.contentFileChecked=true;
        }
      },
      initLanguagetemp(dataTable, dataColumn, dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "hhemp",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            if (dataColumn == 'title') {
              this.contentTitleLanguages = res.result;
            }
          }
        })
      },
      languageOk(map) {
        console.log("map:",map)
        if (map && map.dataColumn == 'contentTitle') {
          this.contentTitleLanguages = map.languagelist;
        } else if (map && map.dataColumn == 'contentSubTitle') {
          this.contentSubTitleLanguages = map.languagelist;
        }else if (map && map.dataColumn == 'remark') {
          this.remarkLanguages = map.languagelist;
        }
      },
      languageModelOpen(dataTable, dataColumn, languagelist) {
        this.$refs.languageModel.edit("hhemp", dataTable, dataColumn, this.model.id, languagelist, this.disabled);
      },
      handleChange(value,files){
        console.log(value,files)
      },
      entranceChange(v){
        this.entranceId = v;
        this.model.colId = '';
        this.model.firstColId='';
        this.classificationId='';
        this.getColList();
      },
      initEntrancelist(){
        getAction("/hhemp/entrance/empcmsentrances",{"status":"Y"}).then(res=>{
          if(res.success){
            this.entrancelist = res.result;
          }
        })
      },
      add () {
        //this.edit(this.modelDefault);
        this.edit({status:'0',linkType:"0"});
        this.colVisible = false;
      },
      edit (record) {
        this.initLanguagetemp('cms_banner', 'title', record.id)
        this.model = Object.assign({}, record);
        this.visible = true;
        this.colVisible = true;
        this.entranceId = record.entranceId
        this.getColList();
        // if(this.colidProps!=null){
        //   //从栏目进来维护就自动选中
        //   this.getColInfo(this.colidProps);
        //   this.initColsDataEdit(this.colidProps);
        //   this.isDisable=true;
        // }
        if(record.id!=null) {
          //初始化栏目
         this.getLangContentData( record.id);
          if ("0" == record.linkType) {
            this.contentTypeChecked=true;
            this.contentFileChecked=false;
          }else{
            this.contentTypeChecked=false;
            this.contentFileChecked=true;
          }
        }

      },
      async getLangContentData(id){
        const res = await getAction("/hhemp/banner/language/queryAllList", {bannerId:id})
        if (res.success) {
          let that=this;
          // console.log("this,model：",this.model,this.langList);
          res.result.forEach(item => {
            let foundObject = that.langList.find(function(obj) {
              return obj.value === item.languageCode;
            });
            if(foundObject!=null){
              that.model[foundObject.imgPath]=item.bannerUrl;
              that.model[foundObject.filePath]=item.filePath;
              that.model[foundObject.introduction]=item.introduction;
              that.model[foundObject.linkUrl]=item.linkUrl;

            }
          })
        }
        this.$nextTick(() => { this.$forceUpdate() })
      },
      getColInfo(colId){
        httpAction("/hhemp/col/cmscoltbl/"+colId, "", "get").then((res) => {
          if (res.success) {
            this.entranceId=res.result.entranceId;
            this.model.entranceId=this.entranceId;
            this.getColList();
          }
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }

            this.contentTitleLanguages.forEach(item => {
              item.langCode= item.templateLangCode;
            })
            // this.contentSubTitleLanguages.forEach(item => {


            this.model.contentTitleLanguages=this.contentTitleLanguages;
            this.model.contentLanguages=[];
            this.langList.forEach(item => {

              let langObj={};
              langObj.langCode=item.value;
              langObj.imgPath=this.model[item.imgPath];
              langObj.filePath=this.model[item.filePath];
              langObj.introduction=this.model[item.introduction];
              langObj.link=this.model[item.linkUrl];
              this.model.contentLanguages.push(langObj)
            })



            if( this.isShowClassification){
              this.model.colId=this.classificationId;
            }else{
              this.model.colId=this.model.firstColId;
            }




            console.log("this.model:",this.model)
           // return ;
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      validateToSortNo(rule, value, callback){
        if(value<1||value>9999){
          callback("输入的值在1到9999之间！");
        }
      },
      getColList(){
        if(!!this.entranceId){
          getAction("/hhemp/col/cmscoltbls/queryallListByLevel", {colLevel:'1',entranceId:this.entranceId}).then((res) => {
            if (res.success) {
              this.cols = res.result;
            }
          })
        }
      },
      colChange(v,data){
        this.colId = v;
        this.model.colId = v;
        let item = this.cols.find(item => item.id === v);
        if(item&&item.colLevel == '1'&&item.templateType=='1'){
          this.isShowClassification = true;
          this.initClassification();
        }else{
          this.classificationId = '';
          this.isShowClassification = false;
        }
      },
      initClassification(){
        getAction("/hhemp/col/getChildrenCmscoltbls", {parentColId:this.model.firstColId,publishStatus:'published'}).then((res) => {
          if (res.success) {
            this.classifications = res.result;
          }
        })
      },
      classificationChange(v){
        this.classificationId = v;
      },
      filecontentChange(){

      },
    }
  }
</script>
<style scoped lang="less">
  .upload-class{
    margin-top: 20px;
  }

</style>
